import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';

import { AuthContext } from '../components/auth/AuthContext';
import { Link } from 'react-router-dom';



function HomePage() {
  const { user} = useContext(AuthContext);

  if (!user || !localStorage.getItem('token')) {
    return(
      <div>
      <Helmet>
        <title>Ortspieler</title>
        <meta name="description" content="Hörspaziergänge vor Ort erleben" />
      </Helmet>
      <div className='main-container'>
        <div><h1>Hinweis</h1></div>
        <div>
          <p>
        Du musst dich anmelden, um diese Anwendung zu nutzen. Verwende dafür deine <Link to="./login">Zugangsdaten</Link> oder einen <Link to="./code">Freischaltcode</Link>.
        </p><p>
        Um eine Hörstation anzuhören, scanne bitte den QR-Code vor Ort mit deiner Kamera. 
        </p>
        </div>
      </div>
      </div>
    ) ; 
  }





  
  return (
    <div>
      <Helmet>
        <title>Ortspieler</title>
        <meta name="description" content="Eine kleine aber feine Anwendung" />
      </Helmet>
      {user ? 
        <div>logge dich ein</div> : <div className='main-container'> Die Cookies werden benötigt </div>
      }
    </div>
  );
}

export default HomePage;